import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';

import { CurrencyPipe, DslService, TrackingService, toBoolean } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [CommonModule, CurrencyPipe, IconCustomComponent],
    selector: 'vn-bonus-balance-sub-item',
    templateUrl: './bonus-balance-sub-item.component.html',
})
export class BonusBalanceSubItemComponent extends AccountMenuItemBase implements OnInit {
    dslService = inject(DslService);
    private trackingService = inject(TrackingService);

    balance: number;
    hideIfZero: boolean;

    ngOnInit(): void {
        this.trackingService.triggerEvent('contentView', {
            'component.CategoryEvent': 'mini menu',
            'component.LabelEvent': 'my bonuses',
            'component.ActionEvent': 'load',
            'component.PositionEvent': 'bonus and rewards',
            'component.LocationEvent': 'wallet',
            'component.EventDetails': this.item.text,
            'component.URLClicked': 'not applicable',
        });
        this.dslService.evaluateExpression<number>(this.item.parameters['formula']!).subscribe((x) => (this.balance = x));
        this.hideIfZero = !!toBoolean(this.item.parameters['hide-if-zero']);
    }
}
